import styled from 'styled-components';

const Title = styled.h1`
  font-size: 18px;
  line-height: 24px;
  font-weight: normal;
  color: #333333;
  margin-bottom: 4px;
  margin-top: 0;
`;

const HeaderWrapper = styled.div`
  height: 55px;
  height: calc(55px + env(safe-area-inset-top));
  width: 100vw;
  background: #f4f4f4;
  box-shadow: 0 1px 0 #dadada;
  position: absolute;
  display: flex;
  align-items: center;
  padding: 0 16px;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  justify-content: space-between;
`;

const MobileBtn = styled.div`
  position: fixed;
  bottom: 5px;
  right: 5px;
`;

const HeaderText = styled.div`
  font-size: 16px;
  line-height: 21px;
  color: #5f5d5b;
`;

const StyledModalBody = styled.div`
  padding: 0 20px 0;
  width: 276px;
  color: #5f5d5b;
  box-sizing: border-box;
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 42px 0 20px;
`;

const BodyWrapper = styled.div`
  padding: 16px;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
`;

export const Styled = {
  Title,
  HeaderWrapper,
  MobileBtn,
  HeaderText,
  StyledModalBody,
  StyledFooter,
  BodyWrapper
};
